import axios from "axios";
import { include } from "../utils/javascript";
import { isAuthenticated, logout } from "./auth";

const successStatus = [200, 201, 204];

const getOrgIdFromStore = () => {
  const store = require("../redux").default;
  return store.getState().org?.active?.id;
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add request interceptor to handle auth and org_id
axiosInstance.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = isAuthenticated();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add org_id to all requests except
    if (!config.url.startsWith("auth/")) {
      const org_id = getOrgIdFromStore();
      if (org_id) {
        config.params = {
          ...config.params,
          org_id,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth and redirect to login
      logout(() => {
        window.location.href = "/";
      });
    }
    return Promise.reject(error);
  }
);

export const api = (
  method,
  urlEndPoint,
  data = null,
  header = {},
  params = {}
) =>
  new Promise((myResolve) => {
    let headers = {
      "Content-Type": header.formData
        ? "multipart/form-data"
        : "application/json",
      "ngrok-skip-browser-warning": 69420,
    };
    headers = {
      ...headers,
      ...header,
    };

    if (headers.formData) {
      delete headers.formData;
    }

    const requestConfig = {
      method,
      url: urlEndPoint,
      headers,
      params,
      ...(method !== "delete" && { data }),
    };

    axiosInstance(requestConfig)
      .then((response) => {
        myResolve({
          message: response.data.message,
          data: response.data.data,
          success: include(successStatus, response.status),
          statusCode: response.data.status,
          count: response?.data?.totalCount || null,
        });
      })
      .catch((err) => {
        if (err.response) {
          if (err?.response?.status >= 500) {
            myResolve({
              message: "Something went wrong.",
              data: err.response.data,
              success: include(successStatus, err.response.status),
            });
          } else {
            myResolve({
              message: err.response.data.message,
              data: err.response.data,
              success: include(successStatus, err.response.status),
            });
          }
        } else {
          myResolve({
            message: err?.toString(),
            data: { ...err },
            success: false,
          });
        }
      });
  });
